module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-estimation-form/assets/image-zero-pressure.6b247b3d6b1c7cf4727820da184bea7c.webp";